import { render, staticRenderFns } from "./DepartmentDetailsView.vue?vue&type=template&id=5fe72eff&"
import script from "./DepartmentDetailsView.vue?vue&type=script&lang=js&"
export * from "./DepartmentDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentDetailsView.vue?vue&type=style&index=0&id=5fe72eff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports